import _ from 'lodash';

export function get(data, key) {
    const value = _.get(data, key);
    return value || '尚未定义';
}
